import "./main-carousal.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

const slides = [
  {
    class: "ai-transformation-img",
    image: "/assets/images/artificial-intelligence.jpg",
    title: "AI Transformation",
    desc: "Leverage the power of Artificial Intelligence to automate workflows, optimize decision-making, and unlock intelligent business insights.",
  },
  {
    class: "digital-transformation-img",
    image: "/assets/images/digital-tranformation-img-2.jpg",
    title: "Digital Transformation",
    desc: "Empower your business with end-to-end digital solutions that streamline operations, enhance efficiency, and drive innovation.",
  },
  {
    class: "management-consultation-img",
    image: "/assets/images/management-consultation.jpg",
    title: "Management Consultation",
    desc: "Transform organizational strategies with expert guidance focused on technology integration, process optimization, and sustainable growth.",
  },
  {
    class: "technical-consultation-img",
    image: "/assets/images/technical-consultation.jpg",
    title: "Technical Consultation",
    desc: "Access tailored IT expertise to architect, implement, and maintain robust technical infrastructures aligned with your business goals.",
  },
];

const MainCarousel = () => {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const goToContact = () => {
    navigate("/contact-us");
  };
  const [current, setCurrent] = useState(0);

  const nextSlide = () =>
    setCurrent((p) => (p === slides.length - 1 ? 0 : p + 1));
  const prevSlide = () =>
    setCurrent((p) => (p === 0 ? slides.length - 1 : p - 1));

  useEffect(() => {
    const t = setInterval(nextSlide, 6000);
    return () => clearInterval(t);
  }, [current]);

  return (
    <div className="carousel-container">
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`carousel-bg ${slides[current].class} ${
            idx === current ? "active" : ""
          }`}
          style={{ backgroundImage: `url(${slide.image})` }}
        ></div>
      ))}

      <div className="carousel-overlay"></div>

      <div className="carousel-flex">
        <button className="carousel-btn" type="button" onClick={prevSlide}>
          <i className="fas fa-chevron-left"></i>
        </button>

        <div className="carousel-content">
          <h1>{t(slides[current].title)}</h1>
          <p>{t(slides[current].desc)}</p>
          <button className="carousal-contact-btn" type="button" onClick={goToContact}>
            {t("Contact Us")}
          </button>
        </div>

        <button className="carousel-btn" type="button" onClick={nextSlide}>
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>

      <div className="carousel-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default MainCarousel;
